module.exports = __webpack_public_path__ + "static/media/epic-banner_fr2.bc33ba67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/epic-banner_fr2.png
// module id = 462
// module chunks = 0